export default "__VITE_ASSET__CJTuGH0M__"